import React from "react";
import {RouteObject} from "react-router-dom";

import {routes} from "./routes";
import {PrivateRouteWrapper} from "./private/PrivateRoute";
import {PublicRouteWrapper} from "./private/PublicRoute";

export const buildAppRoutes = (): RouteObject[] =>
  routes.map(
    ({
      isPrivate,
      restrictedFromAuthorized,
      path,
      zendeskRelatedLabels,
      PageComponent,
      SuspenseFallbackComponent,
      accessRight,
      ...componentProps
    }) => {
      const element = isPrivate ? (
        <PrivateRouteWrapper
          zendeskRelatedLabels={zendeskRelatedLabels}
          PageComponent={PageComponent}
          SuspenseFallbackComponent={SuspenseFallbackComponent}
          componentProps={componentProps}
          accessRight={accessRight}
        />
      ) : (
        <PublicRouteWrapper
          zendeskRelatedLabels={zendeskRelatedLabels}
          PageComponent={PageComponent}
          SuspenseFallbackComponent={SuspenseFallbackComponent}
          componentProps={componentProps}
          restrictedFromAuthorized={restrictedFromAuthorized}
          accessRight={accessRight}
        />
      );

      return {path, element};
    },
  );
